import { useSyncExternalStore } from 'react';
import { apiActivity } from '../../../lib/api/client';

/** Number of API calls in flight right now (every fetch through lib/api/client counts itself in and out). */
export function useApiActivity(): number {
  return useSyncExternalStore(apiActivity.subscribe, apiActivity.inFlight, () => 0);
}
